import { useTranslation } from 'react-i18next';
import IntroBanner from '../components/introBanner';
import StatBanner from '../components/statBanner';
import InfoSection from '../components/infoSection';
import ServicesGrid from '../components/servicesGrid';
import './home.scss'

function Home() {
  const { t } = useTranslation();

  return (
    <div className='homeContainer'>
      <IntroBanner 
        title={t('home.introBannerTitle')} 
        description={t('home.introBannerDesc')}
      />
      
      {/* Trust Signals Bar */}
      {/* <div className='trust-signals-bar'>
        <div className='trust-signals-content'>
          <div className='trust-signal'>
            <svg className='trust-icon' viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="12" cy="12" r="10"/>
              <polyline points="12,6 12,12 16,14"/>
            </svg>
            <span>{t('home.establishedSince')}</span>
          </div>
          <div className='trust-divider'></div>
          <div className='trust-signal'>
            <svg className='trust-icon' viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
            </svg>
            <span>{t('home.siupalLicensed')}</span>
          </div>
          <div className='trust-divider'></div>
          <div className='trust-signal'>
            <svg className='trust-icon' viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
              <polyline points="22 4 12 14.01 9 11.01"/>
            </svg>
            <span>{t('home.bkiClassedFleet')}</span>
          </div>
        </div>
      </div> */}

      <div className="info-section-container">
        <InfoSection title={t('home.introInfoTitle')}>
          <div className='text-content'>
            <p className='info-text'>
              {t('home.introInfoDesc')}
            </p>
          </div>
        </InfoSection>
      </div>
      
      <StatBanner title={t('home.statBannerTitle')} />
      
      <div className="info-section-container services-section">
        <InfoSection title={t('home.servicesTitle')}>
          <ServicesGrid />
        </InfoSection>
      </div>
    </div>
  );
}

export default Home;
